export const FORM_COLLECTION = 'forms';
export const FORM_INSTANCE_COLLECTION = 'form-instances';
export const FORM_RESPONSE_COLLECTION = 'form-responses';



// WEBPACK FOOTER //
// ./src/js/forms/domain/config.js